<template>
  <div class="footer">
    <div class="footer-links">
      <div v-for="page in cms.list" class="footer-link">
        <router-link :to="{ name: 'showPage', params: { type: page.pagetype }}">{{page.title}}</router-link>
      </div>
      <div class="footer-link">
        <router-link :to="{ name: 'contact' }">Kontakt</router-link>
      </div>
    </div>
    <div>
      <Page class="footer-page-template" type="FOOTER" />
    </div>
    <div class="footer-information">
      Dział sprzedaży
      <span class="font-weight-bold">(22) 726 50 40 / (22) 726 50 41</span>
    </div>

    <div class="footer-copy">
      <div>Copyright © 2019 Polypharm SA</div>
      <div>
        NIP:
        <span class="font-weight-bold">5220103650</span> REGON:
        <span class="font-weight-bold">012601084</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Page } from "../RedbayComponents";

export default {
  components: { Page },
  computed: {
    ...mapState({
      cms: state => state.cms
    })
  },
  beforeMount() {
    this.$store.dispatch("cms/getList");
  }
};
</script>



// WEBPACK FOOTER //
// src/components/template/Footer.vue